import React from 'react';
import CampoComboAfectacionIncidencia from '../../../UI/campos/CampoComboAfectacionIncidencia.js';
import CampoEditableNumero from '../../../UI/campos/CampoEditableNumero.js';
import CampoEditableTexto from '../../../UI/campos/CampoEditableTexto.js';
import * as TipoEdicion from '../../../constantes/TipoEdicion.js';
import styles from '../Parametros.module.css';

const campos = {
  CODIGO: 'codigo',
  DESCRIPCION: 'descripcion',
  AFECTACION: 'afectacion',
};

const CamposTipoOficialidad = (props) => {
  const parametro = props.parametro;
  const tipoEdicion = props.tipoEdicion;

  const onAfectacionElegida = (valor) => {
    props.onCampoChange({ ...parametro, afectacion: valor });
  };

  const onCampoChange = (nombre, valor) => {
    switch (nombre) {
      case campos.CODIGO: {
        props.onCampoChange({ ...parametro, codigo: valor });
        break;
      }
      case campos.DESCRIPCION: {
        props.onCampoChange({ ...parametro, descripcion: valor });
        break;
      }
      default:
    }
  };

  return (
    <React.Fragment>
      <table className={`${styles.tablaDatos}`}>
        <tbody>
          <tr>
            <td className={`${styles.titulo}`}>Código</td>
            <td className={`${styles.valor}`}>
              <CampoEditableNumero
                nombre={campos.CODIGO}
                valor={parametro && parametro.codigo}
                editar={tipoEdicion === TipoEdicion.ALTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Descripción</td>
            <td className={`${styles.valor}`}>
              <CampoEditableTexto
                nombre={campos.DESCRIPCION}
                valor={parametro && parametro.descripcion}
                editar={tipoEdicion !== TipoEdicion.CONSULTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Afectación</td>
            <td className={`${styles.valor}`}>
              <CampoComboAfectacionIncidencia
                valor={parametro && parametro.afectacion}
                editar={tipoEdicion !== TipoEdicion.CONSULTA}
                onAfectacionElegida={onAfectacionElegida}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default CamposTipoOficialidad;
